module.exports = __webpack_public_path__ + "static/media/bsd.d3576523.svg";